class Layout {
  constructor() {
    this.gridWidth = process.env.REACT_APP_GRID_WIDTH || 5
    this.gridHeight = process.env.REACT_APP_GRID_HEIGHT || 5
  }

  get gridWidth() {
    return this._gridWidth
  }

  set gridWidth(value) {
    this._gridWidth = value;
    const { innerWidth, innerHeight } = window
    const screenWidth = innerWidth < innerHeight ? innerWidth : innerHeight;
    const isSmallScreen = screenWidth < 600
    let calculatedScreenWidth = 5 * 75    // cell width on a 5x5 grid is 75
    if (isSmallScreen) {
      calculatedScreenWidth = screenWidth - 5 - 5
    }
    this._cellSize = calculatedScreenWidth / value
  }

  get gridHeight() {
    return this._gridHeight
  }

  set gridHeight(value) {
    this._gridHeight = value
  }

  get cellSize() {
    return this._cellSize
  }

  get boardWidth() {
    return this._gridWidth * this._cellSize
  }

  get isBigGrid() {
    return this._gridWidth > 5
  }
}

const instance = new Layout()
export default instance